import React, { useState, useEffect, useRef } from "react";
import logoIcon from "../assets/images/logo-white.png";
import dotsIcon from "../assets/images/dots.svg";
import chartImg from "../assets/images/chartimg.png";
import chartImgSmall from "../assets/images/small-chartimg.png";
import logo from "../assets/images/logo.svg";
import headMobLogo from "../assets/images/logo.svg";
import OTPForm from "../components/OTPForm";
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

const slides = [
  {
    heading: "מנוע AI הראשון בישראל לאיסוף וניתוח נתוני ביטוח ופיננסים",
    description:
      "הבינה המלאכותית כבר כאן, תנו לטכנולוגיה לעבוד בשבילכם ולחסוך לכם כסף. בעזרת כלים טכנולוגים מתקדמים, ידע ותמיכה, אפשר בקלות לשפר את מערכת היחסים שלך עם כסף.",
  },
  {
    heading: "אנחנו מנגישים מידע פיננסי שיעזור לכם לקבל את ההחלטה הנכונה",
    description:
    "אנחנו כאן כדי להנגיש לכם מידע פיננסי בצורה אוביקטיבית, להסביר אותו ולהמליץ במידת הצורך. מה לעשות עם זה ? זאת כבר החלטה שלכם. <br/> המערכת שלנו מאגדת את כל הנתונים הפיננסיים שלכם, בעזרת טכנולוגיית AI מנתחת את האפשרויות הזמינות בשוק,"    
  },
  {
    heading: "מידע פיננסי בגובה העיניים",
    description: "אנחנו אמנם שילוב של אנשי טכנולוגיה ופיננסים ויש לנו נטייה לדבר בשפה שאף אחד אחר לא מבין, אבל לא הפעם, <br/> המערכת שלנו מדברת בשפה שלכם, בצורה פשוטה וברורה, איפה שזה מתחיל להסתבך אנחנו נוסיף הסבר מיוחד. <br/> אם כל זה לא מספיק אנחנו זמינים לכם תמיד בוואטסאפ, תוכלו לשאול ולהתייעץ עם כל מה שלא מסתדר לכם. "
  },
  {
    heading: "שמירה על הפרטיות שלך נמצאת בראש סדר העדיפיות שלנו",
    description: "הגישה שניתנת למידע שלך היא לצורך קריאת הנתונים בלבד, ללא יכולת לבצע פעולות אחרות. טכנולוגיות אבטחת המידע שלנו הן מהמתקדמות בעולם והשירות שלנו עומד בדרישות חוק הגנת הפרטיות, שמירה על מאגרי המידע, והוראות הרשות לניירות ערך."
  },
  {
    heading: "Lorem Ipsum הוא פשוט טקסט דמה של תעשיית הדפוס והקביעה.",
    description: "Lorem Ipsum הוא פשוט טקסט דמה של תעשיית הדפוס והקביעה. Lorem Ipsum היה טקסט הדמה הסטנדרטי של התעשייה מאז"
  }
  ];

const LoginOtp = () => {
    const navigate = useNavigate()
  const location = useLocation();
  const { phoneNumber, email, fullName } = location.state || {};
  useEffect(()=>{    
    if (!phoneNumber) {
      navigate('/register?step=1')
    }
  },[])
  const [activeIndex, setActiveIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const intervalRef = useRef(null);
  const slideRef = useRef(null);
  

  const extendedSlides = [...slides, slides[0]];

  useEffect(() => {
    startAutoSlide();
    return () => clearInterval(intervalRef.current);
  }, []);

  useEffect(() => {
    if (activeIndex === slides.length) {
      const timer = setTimeout(() => {
        setIsTransitioning(false);
        setActiveIndex(0);
      }, 300); 
      return () => clearTimeout(timer);
    }
  }, [activeIndex]);

  const startAutoSlide = () => {
    clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      goToNextSlide();
    }, 3000);
  };

  const goToNextSlide = () => {
    setIsTransitioning(true);
    setActiveIndex(prev => prev + 1);
  };

  const handleIndicatorClick = (index) => {
    if (index > activeIndex) {
      setIsTransitioning(true);
      setActiveIndex(index);
      startAutoSlide();
    }
  };

  const slidesContainerStyle = {
    display: "flex",
    transition: isTransitioning ? "transform 0.3s ease-out" : "none",
    transform: `translateX(${activeIndex * 100}%)`,
  };

  return (
    <div className="login_main">
      <header className="login_mob_head">
        <img src={headMobLogo} className="log_mob-logo" alt="logo" />
      </header>
      <div className="form_main">
         <OTPForm phoneNumber={phoneNumber} email={email} fullName={fullName} />
      </div>
      <div className="form_slider" style={{ overflow: "hidden" }}>
        <div className="loging_logo_div">
          <img src={dotsIcon} alt="dot" />
          <img className="white_logo" src={logoIcon} alt="logo" />
          <img src={dotsIcon} alt="dot" />
        </div>
        <div className="login_mob_head">
          <img src={logo} alt="logo" />
        </div>
       <div className="form_slide_main_outer">
       <div className="form_slide_main" ref={slideRef} style={slidesContainerStyle}>
          {extendedSlides.map((slide, index) => (
            <div
              key={index}
              className="slide_div"
              style={{
                flexShrink: 0,
                width: "100%",
              }}
            >
              <div className="content_wrapper">
                <h2 className="login_head">{slide.heading}</h2>
                <p className="login_desc" dangerouslySetInnerHTML={{ __html: slide.description }}></p>
              </div>
              <div className="chart_view">
                <img
                  draggable={false}
                  className="chart"
                  src={chartImg}
                  alt="chart"
                />
                <div className="small_chart_div">
                  <img
                    draggable={false}
                    className="small_chart"
                    src={chartImgSmall}
                    alt="chart"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="indicator_container">
          {slides.map((_, index) => (
            <div
              onClick={() => handleIndicatorClick(index)}
              key={index}
              className={`indicator ${activeIndex === index ? "active" : ""}`}
            ></div>
          ))}
        </div>
       </div>
      </div>
    </div>
  );
};

export default LoginOtp;